// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ForestTitleBox_wrapper__9_1Bf","treesNumber":"ForestTitleBox_treesNumber__03vqS","updateButton":"ForestTitleBox_updateButton__ZCxYs"};